import React from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SearchSuggestion from "../../../../SubComponents/SearchSuggestion/SearchSuggestion";
import Dropdown from "../../../../SubComponents/Dropdown/Dropdown";
import ReactLoading from "react-loading";
import "./subTopicRepSearch.css";
import { subTopicReportSubmit } from "../../SubTopicReportFunction/subTopicReportSubmit";

function SubTopicReportSearch({
  state,
  formData,
  handleChange,
  submitLoading,
  noData,
  achieverSelected,
  searchSuggestion,
  handleUlClose,
  handleAchieverClick,
  handleOnFocus,
  setSubmitLoading,
  setNoData,
  setNumberOfSubTopicReports,
  setSubTopicReportList,
  limit,
  offSet,
  setStartUpLoad,
  createDownloadInfo,
}) {
  const difficultyLevel = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return (
    <div>
      <form>
        <div className="subTopicReportContainer">
          <h1 className="subTopicReportH3">
            <ArrowForwardIosIcon className="subTopicReportArrow" />
            Sub-Topic Report
          </h1>
        </div>
        <div>
          <div className="subTopicReportSearchContainer">
            <h4 className="subTopicReportHeading">Search Sub-Topic Report</h4>
            <div className="questionViewdropdownDiv">
              <label className="subTopicReportLabel">Created By</label>
              <SearchSuggestion
                achieverSelected={achieverSelected}
                // disabled={editValue}
                handleChange={handleChange}
                searchSuggestion={searchSuggestion}
                dropDownData={state.achieverNameList}
                handleUlClose={handleUlClose}
                handleUlClick={handleAchieverClick}
                handleOnFocus={handleOnFocus}
                name="user_name"
                type="createdBy"
              />
            </div>
            <Dropdown
              label="Medium"
              options={state.medium}
              name="medium_id"
              displayName="medium_name"
              idName="medium_id"
              value={formData.medium_id}
              onChange={handleChange}
              req={false}
            />
            <Dropdown
              label="Questions Type"
              options={state.questionsType}
              displayName="display_name"
              name="question_type_id"
              idName="id"
              value={formData.question_type_id}
              onChange={handleChange}
              req={false}
            >
              {" "}
            </Dropdown>
            <Dropdown
              label="Board"
              options={state.board}
              name="board_id"
              displayName="board_display_name"
              idName="board_id"
              value={formData.board_id}
              onChange={handleChange}
              req={false}
            />
            <Dropdown
              label="Course"
              options={state.course}
              name="course_id"
              displayName="display_name"
              idName="course_id"
              value={formData.course_id}
              onChange={handleChange}
              req={false}
            />
            <Dropdown
              label="Subject"
              options={state.subject}
              name="subject_id"
              displayName="display_name"
              idName="subject_id"
              value={formData.subject_id}
              onChange={handleChange}
              req={false}
            />
            <Dropdown
              label="Sub-Subject"
              options={state.subSubject}
              name="sub_subject_id"
              displayName="display_name"
              idName="sub_subject_id"
              value={formData.sub_subject_id}
              onChange={handleChange}
              req={false}
              displayEngName={"display_name_eng"}
            />
            <Dropdown
              label="Topic"
              options={state.topic}
              name="topic_id"
              displayName="display_name"
              idName="topic_id"
              value={formData.topic_id}
              onChange={handleChange}
              req={false}
              displayEngName={"display_name_eng"}
            />
            <Dropdown
              label="Taxonomy"
              options={state.taxonomies}
              displayName="display_name"
              name="taxonomy_id"
              idName="id"
              onChange={handleChange}
              value={formData.taxonomy_id}
              req={false}
            />
            <Dropdown
              label="Objective"
              options={state.objectives}
              displayName="objective_code"
              name="objective_id"
              idName="objective_id"
              onChange={handleChange}
              value={formData.objective_id}
              req={false}
            />
            <Dropdown
              label="Difficulty Level"
              options={difficultyLevel}
              name="difficulty_level"
              displayName=""
              value={formData.difficulty_level}
              onChange={handleChange}
              req={false}
            />
            <div className="subTopicReportDropdownDiv">
              <label className="subTopicReportLabel">From Date</label>
              <input
                className="subTopicReportSelect"
                type="date"
                value={formData.from_date}
                onChange={(e) => handleChange(e, "from_date")}
              ></input>
            </div>
            <div className="subTopicReportDropdownDiv">
              <label className="subTopicReportLabel">To Date</label>
              <input
                className="subTopicReportSelect"
                type="date"
                value={formData.to_date}
                onChange={(e) => handleChange(e, "to_date")}
              ></input>
            </div>
            <div className="topicReportDropdownDiv">
              <div className="topicReportLabel">Curated</div>
              <div className="topicReportRadio">
                <div>
                  <input
                    type="radio"
                    id="curated"
                    name="fav_language"
                    value={"curated"}
                    onChange={(e) => {
                      console.log(e, e.target.value, e.target.checked);
                      handleChange(e, "is_curated");
                    }}
                  />
                  <label htmlFor="curated">Curated</label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="non_curated"
                    name="fav_language"
                    value={"non_curated"}
                    onChange={(e) => {
                      console.log(e, e.target.value, e.target.checked);
                      handleChange(e, "is_curated");
                    }}
                  />
                  <label htmlFor="non_curated">Non Curated</label>
                </div>
                <div>
                  <input
                    type="radio"
                    id="all"
                    name="fav_language"
                    value={"all"}
                    defaultChecked={formData?.is_curated === "all"}
                    onChange={(e) => {
                      console.log(e, e.target.value, e.target.checked);
                      handleChange(e, "is_curated");
                    }}
                  />
                  <label htmlFor="all">All</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="subTopicReportSearchButtonContainer">
          <button
            className="subTopicReportSearchBtn"
            id="searchQuestions"
            type="button"
            onClick={(e) => {
              subTopicReportSubmit(
                setSubmitLoading,
                setNoData,
                formData,
                setNumberOfSubTopicReports,
                setSubTopicReportList,
                limit,
                offSet,
                setStartUpLoad
              );
              createDownloadInfo(formData);
            }}
          >
            Search
          </button>
          {submitLoading ? (
            <div className="subTopicReportloadingDiv">
              <ReactLoading
                type="spinningBubbles"
                color="#68dff0"
                className="subTopicRepReactLoadingIcon"
              />
              <h5 className="loadingText">Loading</h5>
            </div>
          ) : null}
          {noData ? (
            <div className="subTopicReportloadingDiv">
              <h5 className="subTopicRepLoadingTextData">
                Data is not available
              </h5>
            </div>
          ) : null}
        </div>
      </form>
    </div>
  );
}

export default SubTopicReportSearch;
